module.exports = __webpack_public_path__ + "img/bangding.03469d08.png";